import React, { useEffect, useState } from 'react';
import { Typography, Box, Grid, Button, Paper, colors } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { axiosPostCall } from '../../services/apisCall';
import { BarChart } from 'src/components/circular-progress-chart/Bar-chart';
import { RadialBar } from 'src/components/circular-progress-chart/RadialBar-chart';
import { ColumnChart } from 'src/components/circular-progress-chart/Column-chart';
const EmailStatus = () => {
  const [inboundData, setInboundData] = useState({
    mailReceived: 0,
    mailDeferred: 0,
    mailBounced: 0,
    totalMail: 0,
  });
  const [delivered, setDelivered] = useState({});
  const [deferredData, setDeferredData] = useState({});
  const [bouncedData, setBouncedData] = useState({});

  const [topData, setTopData] = useState({ mail: [], host: [] });

  const [inboundDelivered, setInboundDelivered] = useState({});
  const [inBoundDeferred, setInBoundDeferred] = useState({});
  const [inboundBounced, setInboundBounced] = useState({});
  const [inboundReceiver, setInboundReceiver] = useState({ mail: [], host: [] });
  const [inboundSender, setInboundSender] = useState({ mail: [], host: [] });

  const [outboundData, setOutboundData] = useState({
    mailSent: 0,
    mailDeferred: 0,
    mailBounced: 0,
    totalMail: 0,
  });

  const [dateRange, setDateRange] = useState({
    startDate: dayjs().subtract(30, 'day'),
    endDate: dayjs(),
  });

  const fetchData = async () => {
    try {
      const from = dateRange.startDate?.format('YYYY-MM-DD');
      const to = dateRange.endDate?.format('YYYY-MM-DD');
      const { inbound, outbound } = await axiosPostCall('email_stats_dashboard', {
        rangeType: 'custom',
        intervalTime: '3h',
        from,
        to,
      });
      const {
        top: { delivered, deferred, bounced, mail, host },
      } = outbound;

      const {
        top: {
          received,
          deferred: inBoundDeferred,
          bounced: inBoundBounced,
          receiverMail,
          receiverhost,
          senderhost,
          senderMail,
        },
      } = inbound;
      setInboundDelivered(received);
      setInBoundDeferred(inBoundDeferred);
      setInboundBounced(inBoundBounced);
      setInboundReceiver({ mail: receiverMail, host: receiverhost });
      setInboundSender({ mail: senderMail, host: senderhost });
      setDelivered(delivered);
      setDeferredData(deferred);
      setTopData({ mail, host });
      setBouncedData(bounced);
      setInboundData({
        mailReceived: inbound?.mailReceived || 0,
        mailDeferred: inbound?.mailDeferred || 0,
        mailBounced: inbound?.mailBounced || 0,
        totalMail: inbound?.totalMail || 0,
      });

      setOutboundData({
        mailSent: outbound?.mailSent || 0,
        mailDeferred: outbound?.mailDeferred || 0,
        mailBounced: outbound?.mailBounced || 0,
        totalMail: outbound?.totalMail || 0,
      });
    } catch (error) {
      console.error('Error fetching mail stats:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  function separateValues(data) {
    let key = [];
    let count = [];
    data?.forEach((item) => {
      key.push(item.key);
      count.push(item.count);
    });
    return { key, count };
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box
        sx={{
          backgroundColor: '#edeff2',
          height: '100vh',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          p: 2,
        }}
      >
        <Typography variant="h6" sx={{ mb: 2 }}>
          Mail Status
        </Typography>

        <Paper
          sx={{
            flex: 1,
            overflowY: 'auto',
            backgroundColor: '#fff',
            borderRadius: 2,
            p: 3,
          }}
        >
          {/* Filters */}
          <Box sx={{ display: 'flex', gap: 2, mb: 4, flexWrap: 'wrap' }}>
            <DatePicker
              label="Start Date"
              value={dateRange.startDate}
              onChange={(newValue) => setDateRange((prev) => ({ ...prev, startDate: newValue }))}
              slotProps={{
                textField: {
                  size: 'small',
                  sx: { width: 160 },
                },
              }}
            />
            <DatePicker
              label="End Date"
              value={dateRange.endDate}
              onChange={(newValue) => setDateRange((prev) => ({ ...prev, endDate: newValue }))}
              minDate={dateRange.startDate}
              slotProps={{
                textField: {
                  size: 'small',
                  sx: { width: 160 },
                },
              }}
            />
            <Button variant="contained" onClick={fetchData} disabled={!dateRange.startDate || !dateRange.endDate}>
              Apply Filter
            </Button>
          </Box>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Outbound Mail Status
          </Typography>
          {/* Radial Chart */}
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: '10px', mb: 5 }}>
            <Box sx={{ width: '500px', height: '200px', textAlign: 'center' }}>
              <RadialBar
                title="Outbound Chart"
                total={outboundData.totalMail}
                chart={{
                  series: [
                    { label: 'Mail Sended ', value: outboundData.mailSent },
                    { label: 'Deferred Mail', value: outboundData.mailDeferred },
                    { label: 'Bounced Mail', value: outboundData.mailBounced },
                  ],
                }}
              />
            </Box>

            <Box sx={{ width: '500px', height: '450px', textAlign: 'center' }}>
              <ColumnChart
                title="Outbound Delivered Mail Stats"
                color="#00897b"
                chart={{
                  series: [
                    {
                      name: 'Monthly',
                      categories: separateValues(delivered.mail).key,
                      data: [{ name: 'Mail', data: separateValues(delivered.mail).count }],
                    },
                  ],
                }}
              />
            </Box>
            <Box sx={{ width: '500px', height: '450px', textAlign: 'center' }}>
              <ColumnChart
                title="Outbound Delivered Host Stats"
                color="#8e24aa"
                chart={{
                  series: [
                    {
                      name: 'Monthly',
                      categories: separateValues(delivered.host).key,
                      data: [
                        // { },
                        { name: 'Host', data: separateValues(delivered.host).count },
                      ],
                    },
                  ],
                }}
              />
            </Box>
            {/* </Grid> */}
            {/* </Box> */}
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: '10px', mb: 5 }}>
            <Box sx={{ width: '500px', height: '500px', textAlign: 'center' }}>
              <BarChart
                title=" Outbound Top Mail Stats"
                chart={{
                  colors: ['#43a047'],
                  categories: separateValues(topData.mail).key,
                  series: [{ name: 'Mail', data: separateValues(topData.mail).count }],
                }}
              />
            </Box>
            <Box sx={{ width: '500px', height: '450px', textAlign: 'center' }}>
              <BarChart
                title=" Outbound Top Host Stats"
                chart={{
                  colors: ['#e53935'],
                  categories: separateValues(topData.host).key,
                  series: [{ name: 'Host', data: separateValues(topData.host).count }],
                }}
              />
            </Box>
            <Box sx={{ width: '500px', height: '450px', textAlign: 'center' }}>
              <ColumnChart
                title="Outbound Bounced Mail Stats"
                color="#FF9800"
                chart={{
                  series: [
                    {
                      name: 'Monthly',
                      categories: separateValues(bouncedData.mail).key,
                      data: [
                        // { },
                        { name: 'Mail', data: separateValues(bouncedData.mail).count },
                      ],
                    },
                  ],
                }}
              />
            </Box>
            <Box sx={{ width: '500px', height: '450px', textAlign: 'center' }}>
              <ColumnChart
                title="Outbound Bounced Host Stats"
                color="#43632a"
                chart={{
                  series: [
                    {
                      name: 'Monthly',
                      categories: separateValues(bouncedData.host).key,
                      data: [
                        // { },
                        { name: 'Host', data: separateValues(bouncedData.host).count },
                      ],
                    },
                  ],
                }}
              />
            </Box>
          </Box>
          {/* /////////////////////////////////////////// */}
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: '10px', mb: 5 }}>
            <Box sx={{ width: '500px', height: '450px', textAlign: 'center' }}>
              <ColumnChart
                title="Outbound Deferred Mail Stats"
                color="#546e7a"
                chart={{
                  series: [
                    {
                      name: 'Monthly',
                      categories: separateValues(deferredData.mail).key,
                      data: [{ name: 'Mail', data: separateValues(deferredData.mail).count }],
                    },
                  ],
                }}
              />
            </Box>
            <Box sx={{ width: '500px', height: '450px', textAlign: 'center' }}>
              <ColumnChart
                title="Outbound Deferred Hst Stats"
                color="#f4511e"
                chart={{
                  series: [
                    {
                      name: 'Monthly',
                      categories: separateValues(deferredData.host).key,
                      data: [
                        // { },
                        { name: 'Host', data: separateValues(deferredData.host).count },
                      ],
                    },
                  ],
                }}
              />
            </Box>
            {/* </Grid> */}
          </Box>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Inbound Mail Status
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: '10px', mb: 5 }}>
            <Box sx={{ width: '500px', height: '200px', textAlign: 'center' }}>
              <RadialBar
                title="Inbound Chart"
                total={inboundData.totalMail}
                chart={{
                  series: [
                    { label: 'Mail Received  ', value: inboundData.mailReceived },
                    { label: 'Deferred Mail', value: outboundData.mailDeferred },
                    { label: 'Bounced Mail', value: outboundData.mailBounced },
                  ],
                }}
              />
            </Box>

            <Box sx={{ width: '500px', height: '450px', textAlign: 'center' }}>
              <ColumnChart
                title="Inbound Delivered Mail Stats"
                color="#00897b"
                chart={{
                  series: [
                    {
                      name: 'Monthly',
                      categories: separateValues(inboundDelivered.mail).key,
                      data: [{ name: 'Mail', data: separateValues(inboundDelivered.mail).count }],
                    },
                  ],
                }}
              />
            </Box>
            <Box sx={{ width: '500px', height: '450px', textAlign: 'center' }}>
              <ColumnChart
                title="Inbound Delivered Host Stats"
                color="#8e24aa"
                chart={{
                  series: [
                    {
                      name: 'Monthly',
                      categories: separateValues(inboundDelivered.host).key,
                      data: [
                        // { },
                        { name: 'Host', data: separateValues(inboundDelivered.host).count },
                      ],
                    },
                  ],
                }}
              />
            </Box>
            {/* </Grid> */}
            {/* </Box> */}
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: '10px', mb: 5 }}>
            <Box sx={{ width: '500px', height: '500px', textAlign: 'center' }}>
              <BarChart
                title=" Inbound Deferred Mail Stats"
                chart={{
                  colors: ['#43a047'],
                  categories: separateValues(inBoundDeferred.mail).key,
                  series: [{ name: 'Mail', data: separateValues(inBoundDeferred.mail).count }],
                }}
              />
            </Box>
            <Box sx={{ width: '500px', height: '450px', textAlign: 'center' }}>
              <BarChart
                title=" Inbound Deferred Host Stats"
                chart={{
                  colors: ['#e53935'],
                  categories: separateValues(inBoundDeferred.host).key,
                  series: [{ name: 'Host', data: separateValues(inBoundDeferred.host).count }],
                }}
              />
            </Box>
            <Box sx={{ width: '500px', height: '450px', textAlign: 'center' }}>
              <ColumnChart
                title="Inbound Bounced Mail Stats"
                color="#FF9800"
                chart={{
                  series: [
                    {
                      name: 'Monthly',
                      categories: separateValues(inboundBounced.mail).key,
                      data: [
                        // { },
                        { name: 'Mail', data: separateValues(inboundBounced.mail).count },
                      ],
                    },
                  ],
                }}
              />
            </Box>
            <Box sx={{ width: '500px', height: '450px', textAlign: 'center' }}>
              <ColumnChart
                title="Inbound Bounced Host Stats"
                color="#43632a"
                chart={{
                  series: [
                    {
                      name: 'Monthly',
                      categories: separateValues(inboundBounced.host).key,
                      data: [
                        // { },
                        { name: 'Host', data: separateValues(inboundBounced.host).count },
                      ],
                    },
                  ],
                }}
              />
            </Box>
          </Box>
          {/* /////////////////////////////////////////// */}
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: '10px', mb: 5 }}>
            <Box sx={{ width: '500px', height: '450px', textAlign: 'center' }}>
              <ColumnChart
                title="Inbound Receiver Mail Stats"
                color="#546e7a"
                chart={{
                  series: [
                    {
                      name: 'Monthly',
                      categories: separateValues(inboundReceiver.mail).key,
                      data: [{ name: 'Mail', data: separateValues(inboundReceiver.mail).count }],
                    },
                  ],
                }}
              />
            </Box>
            <Box sx={{ width: '500px', height: '450px', textAlign: 'center' }}>
              <ColumnChart
                title="Inbound Receiver Hst Stats"
                color="#f4511e"
                chart={{
                  series: [
                    {
                      name: 'Monthly',
                      categories: separateValues(inboundReceiver.host).key,
                      data: [
                        // { },
                        { name: 'Host', data: separateValues(inboundReceiver.host).count },
                      ],
                    },
                  ],
                }}
              />
            </Box>
            <Box sx={{ width: '500px', height: '450px', textAlign: 'center' }}>
              <ColumnChart
                title="Inbound Sender Mail Stats"
                color="#FFC107"
                chart={{
                  series: [
                    {
                      name: 'Monthly',
                      categories: separateValues(inboundSender.mail).key,
                      data: [{ name: 'Mail', data: separateValues(inboundSender.mail).count }],
                    },
                  ],
                }}
              />
            </Box>
            <Box sx={{ width: '500px', height: '450px', textAlign: 'center' }}>
              <ColumnChart
                title="Inbound Sender Host Stats"
                color="#3F51B5"
                chart={{
                  series: [
                    {
                      name: 'Monthly',
                      categories: separateValues(inboundSender.host).key,
                      data: [
                        // { },
                        { name: 'Host', data: separateValues(inboundSender.host).count },
                      ],
                    },
                  ],
                }}
              />
            </Box>
            {/* </Grid> */}
          </Box>{' '}
        </Paper>
      </Box>
    </LocalizationProvider>
  );
};

export default EmailStatus;
